if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('no-inert') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header site-header'

				if ( this.classList.contains('site-header--style-one-row') ) {

					stickyHeader.innerHTML = `<div class="container--large">
						<div class="${this.querySelector('.header__top').className }" style="height:calc(var(--header-logo) + var(--header-vertical-space))">
							${this.querySelector('.header__top').innerHTML}
						</div>
					</div>`;
					stickyHeader.className = `sticky-header ${this.className}`;
					stickyHeader.classList.remove('site-header--absolute');

				} else {

					stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
						${this.querySelector('.header__bottom').innerHTML}
						<div style="display:flex;gap:15px;">
							${this.querySelector('.area--custom-icon') ? this.querySelector('.area--custom-icon').outerHTML : ''}
							${this.querySelector('.area--search').outerHTML}
							${this.querySelector('.area--account') ? this.querySelector('.area--account').outerHTML : ''}
							${this.querySelector('.area--cart').outerHTML}
						</div>
					</div>
					<div class="site-header element--hide-on-portable-plus">
						${this.querySelector('.header-container--top').innerHTML}
					</div>`;
					
				}
			
				document.body.append(stickyHeader);
				
				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('.site-nav [aria-controls]').forEach(elm=>{
					elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
				});

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound =  this.classList.contains('site-header--style-one-row') ? this.querySelector('.header__top') : this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				this.SCROLL_StickyHelper = () => {

					var st = window.scrollY;

					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.style.transition = 'none';
						stickyHeader.classList.remove('show');
						requestAnimationFrame(function() { stickyHeader.style.transition = ''; });
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;

					// Show at bottom of page
					var atBottom = (window.innerHeight + st) >= (document.body.scrollHeight - 100);

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.style.transition = 'none';
							stickyHeader.classList.remove('show');
							requestAnimationFrame(function() { stickyHeader.style.transition = ''; });

						} else if ( ( st <= lst || atBottom ) && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							stickyHeader.classList.add('show');

						} else if ( st > lst && !atBottom && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
						}

					}

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
				
			}

			// drawer connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			});
			if ( this.classList.contains('site-header--alignment-left') || this.classList.contains('site-header--style-one-row') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}
			if ( this.classList.contains('site-header--style-one-row') && this.classList.contains('site-header--alignment-center') ) {
				document.getElementById('site-menu-sidebar').classList.remove('sidebar--right');
				document.getElementById('site-menu-sidebar').classList.add('sidebar--left');
			}
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
			document.body.classList.add('header-loaded');

			// switch menu (on load and on resize)
			this._previousWidth = window.innerWidth;
			this._checkMenuWidth();
			this._checkMenuWidth();

			window.addEventListener('resize', debounce(()=>{
				const currentWidth = window.innerWidth;
				if ( currentWidth < this._previousWidth ) {
					this._checkMenuWidth();
				}
				this._previousWidth = currentWidth;
			}, 200));

			// submenu masonry

			document.querySelectorAll('.site-nav.style--classic .submenu-masonry').forEach(elm=>{
				if ( Macy ) {
					const submenuMacy = new Macy({
						container: elm,
						columns: parseInt(elm.getAttribute('data-columns')),
						margin: 30
					});
					setTimeout(()=>{
						submenuMacy.reInit();
					}, 100);
				}
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

				// predictive search (sidebar)

				document.querySelectorAll('[data-js-open-search-drawer').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
						setTimeout(()=>{
							document.querySelector('#search-form-sidebar').focus();
						}, 10)
					});
				});

			} else {

				this.querySelector('search-form').addEventListener('click', e=>{
					e.preventDefault();
					window.location.href = KROWN.settings.routes.search_url;
				});

			}

			// touch menu helpers

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			if ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) {
				document.querySelectorAll('.style--classic .has-babymenu > a').forEach(elmLink=>{
					const elm = elmLink.parentElement;
					elmLink.addEventListener('click', e=>{
						e.preventDefault();
						e.stopPropagation();
						elm.classList.toggle('focus');
						babyMenuTouch = true;
						closeTouchSubmenus(elm,elm.closest('.has-submenu'));
					})
				})
				document.querySelectorAll('.style--classic .has-submenu > a').forEach(elmLink=>{
					const elm = elmLink.parentElement;
					if ( ! elm.classList.contains('mega-link') ) {
						elmLink.addEventListener('click', e=>{
							e.preventDefault();
							e.stopPropagation();
							if ( ! babyMenuTouch ) {
								elm.classList.toggle('focus');
								closeTouchSubmenus(elm);
							}
							babyMenuTouch = false;
						})
					}
				});
			}

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			window.removeEventListener('scroll', this.SCROLL_StickyHelper);
			document.querySelector('.sticky-header')?.remove();
		}

		_checkMenuWidth() {
			
			const header = document.querySelector('.site-header--menu-classic');
			if ( !header ) {
				return;
			}

			const classicMenu = header.querySelector('.area--menu-classic');
			if ( !classicMenu ) {
				return;
			}
			
			const logo = header.querySelector('.area--logo');
			const logoIsCentered = header.classList.contains('header__top--logo-center');
			let availWidthforClassicMenu = 0;

			const headerStyle = window.getComputedStyle(header);
			const headerPaddingRight = parseFloat(headerStyle.getPropertyValue('padding-right'));
		  const headerPaddingLeft = parseFloat(headerStyle.getPropertyValue('padding-left'));
		  const headerRowGap = 10;

			const headerWidth = header.offsetWidth - headerPaddingLeft - headerPaddingRight;
			const logoWidth = logo.offsetWidth;
			const classicMenuWidth = classicMenu.offsetWidth + headerRowGap;
			
			const headerItems = header.children;
		
			// Calculate the total width of the child elements
			let totalWidthOfHeaderItems = 0;
			for (let i = 0; i < headerItems.length; i++) {
				if(headerItems[i].offsetWidth > 0) {
					totalWidthOfHeaderItems += headerItems[i].offsetWidth + headerRowGap;
				}
			}

			totalWidthOfHeaderItems -= headerRowGap; // grid gap for one element (gap is inner space :) )

			if( logoIsCentered ) {
				availWidthforClassicMenu = headerWidth / 2 - logoWidth / 2 - headerRowGap; // consider the gap
			} else {
				let otherElementsWidth = totalWidthOfHeaderItems - logoWidth - classicMenuWidth;
				availWidthforClassicMenu = headerWidth - otherElementsWidth - logoWidth;
			}

			// If no available space for classic menu, convert menu to minimal
			if ( classicMenuWidth > availWidthforClassicMenu ) {
				header.classList.remove('site-header--menu-classic');
				header.classList.add('site-header--menu-minimal');
				classicMenu.remove();
			} 
		}

		_adjustNavLayout() {
			if ( this.querySelector('.site-nav') && this.querySelector('.site-nav').classList.contains('style--classic') ) {

				if ( this.querySelector('nav > ul').scrollWidth > this.querySelector('nav').offsetWidth ) {
					this.classList.add('site-header--swap-menu-style');
					document.body.classList.remove('header--has-two-rows');
					let header = document.getElementById('site-header');
					let twoRowsDetected = header.querySelectorAll('[class*="two-rows"]');
					twoRowsDetected.forEach(el=>{
						el.className = el.className.replace('two-rows', 'one-row');
					});
				}
			}
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this._opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id == 'site-cart-sidebar' && document.getElementById('cart-recommendations-sidebar') ) {
				setTimeout(()=>{
					document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
				}, 10);
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				if ( window.inertElems ) {
					window.inertElems.forEach(elm=>{
						elm.setAttribute('inert', '');
					})
				}
			}, 15);

		}

		hide(){

			this._opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			if ( window.inertElems ) {
				window.inertElems.forEach(elm=>{
					elm.removeAttribute('inert');
				})
			}

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

		}

		_resizeContainer(main=false){
			if ( main ) {
				this.style.height = `auto`;
			} else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
			}
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}


/* ============================================
   BBFC: Mobile Menu
   Delete ALL old BBFC mobile menu JS.
   Paste at END of header JS file.
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  var mobileNav = document.querySelector('mobile-navigation');
  var sidebar = document.getElementById('site-menu-sidebar');
  if (!mobileNav || !sidebar) return;

  /* === BACK ARROW IN HEADER === */
  
  var header = sidebar.querySelector('.sidebar__header');
  if (header) {
  var backArrow = document.createElement('button');
backArrow.textContent = '← BACK';
backArrow.style.cssText = 'background:none;border:none;color:rgba(255,255,255,0.6);font-size:14px;font-weight:600;cursor:pointer;padding:20px;display:none;z-index:2;position:absolute;left:20px;top:40px;letter-spacing:0.5px;';
    backArrow.id = 'bbfc-back-arrow';
    header.insertBefore(backArrow, header.firstChild);

backArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      mobileNav._openedFirstSubmenu = false;
      mobileNav._openedSecondSubmenu = false;
      mobileNav.classList.remove('opened-first-submenu');
      mobileNav.classList.remove('opened-second-submenu');
      mobileNav.style.height = 'auto';
      setTimeout(function() {
        mobileNav.querySelectorAll('li.opened').forEach(function(li) {
          li.classList.remove('opened');
        });
      }, 50);
      backArrow.style.display = 'none';
      // Re-show level 1 links
      mobileNav.querySelectorAll('.link-list > li').forEach(function(li) {
        li.style.visibility = 'visible';
        li.style.opacity = '1';
        li.style.position = 'relative';
      });
    });
  }

  // Show/hide back arrow based on submenu state
  var backObserver = new MutationObserver(function() {
    var arrow = document.getElementById('bbfc-back-arrow');
    if (arrow) {
      arrow.style.display = mobileNav.classList.contains('opened-first-submenu') ? 'block' : 'none';
    }
  });
  backObserver.observe(mobileNav, { attributes: true, attributeFilter: ['class'] });

  /* === RESET TO LEVEL 1 ON CLOSE === */

  var closeBtn = sidebar.querySelector('[data-js-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      setTimeout(function() {
        mobileNav.classList.remove('opened-first-submenu');
        mobileNav.classList.remove('opened-second-submenu');
        mobileNav._openedFirstSubmenu = false;
        mobileNav._openedSecondSubmenu = false;
        mobileNav.style.height = 'auto';
        mobileNav.querySelectorAll('li.opened').forEach(function(li) {
          li.classList.remove('opened');
        });
        var arrow = document.getElementById('bbfc-back-arrow');
        if (arrow) arrow.style.display = 'none';
        mobileNav.querySelectorAll('.link-list > li').forEach(function(li) {
          li.style.cssText = '';
        });
      }, 100);
    });
  }

  var overlay = document.querySelector('.site-overlay');
  if (overlay) {
    overlay.addEventListener('click', function() {
      setTimeout(function() {
        mobileNav.classList.remove('opened-first-submenu');
        mobileNav.classList.remove('opened-second-submenu');
        mobileNav._openedFirstSubmenu = false;
        mobileNav._openedSecondSubmenu = false;
        mobileNav.style.height = 'auto';
        mobileNav.querySelectorAll('li.opened').forEach(function(li) {
          li.classList.remove('opened');
        });
        var arrow = document.getElementById('bbfc-back-arrow');
        if (arrow) arrow.style.display = 'none';
        mobileNav.querySelectorAll('.link-list > li').forEach(function(li) {
          li.style.cssText = '';
        });
      }, 100);
    });
  }

  /* === BABYMENU FLATTENING === */

  var navObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('opened-first-submenu')) {
        var openedItem = mutation.target.querySelector('.has-submenu.opened');
        if (openedItem) {
          var submenu = openedItem.querySelector('.submenu');
          if (submenu) {
            submenu.querySelectorAll('.babymenu').forEach(function(baby) {
              baby.style.cssText = 'display:block!important;position:relative!important;visibility:visible!important;opacity:1!important;height:auto!important;overflow:visible!important;transform:none!important;width:100%!important;padding:0!important;margin:0!important;background:transparent!important;left:auto!important;top:auto!important;z-index:auto!important;clip-path:none!important;transition:none!important;';
              baby.querySelectorAll('li').forEach(function(li) {
                li.style.cssText = 'display:block!important;opacity:1!important;visibility:visible!important;transform:none!important;';
              });
            });

            // Stagger animate sections
            var sections = submenu.querySelectorAll('.has-babymenu');
            sections.forEach(function(section, i) {
              section.style.opacity = '0';
              section.style.transform = 'translateY(12px)';
              section.style.transition = 'none';
              setTimeout(function() {
        section.style.transition = 'opacity 0.75s ease, transform 0.75s ease';
                section.style.opacity = '1';
                section.style.transform = 'translateY(0)';
              }, 300 + (i * 120));
            });
          }
        }
      }
    });
  });
  navObserver.observe(mobileNav, { attributes: true, attributeFilter: ['class'] });

  /* === PREVENT THIRD-LEVEL DRILL === */

  mobileNav.querySelectorAll('.submenu .has-babymenu > a').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      var href = link.getAttribute('href');
      if (href && href !== '#' && href !== '') {
        window.location.href = href;
      }
      e.preventDefault();
    }, true);
  });

  /* === STAGGER ANIMATE LEVEL 1 ON OPEN === */

  var sidebarObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('sidebar--opened')) {
        var links = mobileNav.querySelectorAll('.link-list > li');
        links.forEach(function(li, i) {
          li.style.opacity = '0';
          li.style.transform = 'translateY(15px)';
          li.style.transition = 'none';
                    setTimeout(function() {
            li.style.transition = 'opacity 0.75s ease, transform 0.75s ease';
            li.style.opacity = '1';
            li.style.transform = 'translateY(0)';
          }, 300 + (i * 100));
        });
      } else {
        var links = mobileNav.querySelectorAll('.link-list > li');
        links.forEach(function(li) {
          li.style.opacity = '0';
          li.style.transform = 'translateY(15px)';
          li.style.transition = 'none';
        });
      }
    });
  });
  sidebarObserver.observe(sidebar, { attributes: true, attributeFilter: ['class'] });

  /* === HIDE THEME BACK BUTTON (we use header arrow instead) === */

  var style = document.createElement('style');
  style.textContent = 'mobile-navigation .submenu > .submenu-back, mobile-navigation .submenu > li.submenu-back { display:none!important; }';
  document.head.appendChild(style);

});

/* Desktop mega menu hover bridge + sliding indicator */
(function() {
    if ('ontouchstart' in window) return;

    var holdTimer = null;
    var heldItem = null;
    var hideTimer = null;
    var lastItem = null;
    var activeInd = null; /* currently active indicator element */

    function getIndicatorFor(li) {
        var navUl = li.closest('nav > ul') || li.parentElement;
        if (!navUl) return null;
        var ind = navUl.querySelector('.nav-slide-indicator');
        if (!ind) {
            ind = document.createElement('div');
            ind.className = 'nav-slide-indicator';
            navUl.style.position = 'relative';
            navUl.appendChild(ind);
        }
        return ind;
    }

    function moveIndicator(li, instant) {
        var ind = getIndicatorFor(li);
        if (!ind) return;

        /* If switching between navs (main ↔ sticky), hide the old one */
        if (activeInd && activeInd !== ind) {
            activeInd.classList.remove('is-visible');
        }
        activeInd = ind;

        var navUl = ind.parentElement;
        var ulRect = navUl.getBoundingClientRect();

        /* Measure the text span, not the full li */
        var textSpan = li.querySelector('.menu-link > span > span') || li.querySelector('.menu-link span');
        var target = textSpan || li;
        var tRect = target.getBoundingClientRect();

        var newLeft = tRect.left - ulRect.left;
        var newWidth = tRect.width;
        var newTop = (tRect.bottom - ulRect.top) + 5; /* 5px below text */

        clearTimeout(hideTimer);

        if (instant || !lastItem) {
            ind.classList.remove('is-visible');
            ind.classList.add('no-transition');
            ind.style.left = newLeft + 'px';
            ind.style.width = newWidth + 'px';
            ind.style.top = newTop + 'px';
            ind.offsetHeight; /* force reflow */
            ind.classList.remove('no-transition');
        } else {
            ind.style.left = newLeft + 'px';
            ind.style.width = newWidth + 'px';
            ind.style.top = newTop + 'px';
        }
        ind.classList.add('is-visible');
        lastItem = li;
    }

    function hideIndicator(delay) {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function() {
            if (activeInd) {
                activeInd.classList.remove('is-visible');
            }
            lastItem = null;
        }, delay || 400);
    }

    document.addEventListener('mouseout', function(e) {
        var li = e.target.closest('.site-nav.style--classic .has-submenu');
        if (!li) return;
        if (li.contains(e.relatedTarget)) return;

        heldItem = li;
        li.classList.add('submenu-hold');
        holdTimer = setTimeout(function() {
            li.classList.remove('submenu-hold');
            heldItem = null;
        }, 400);

        /* Start hide countdown — cancelled if mouse enters another item */
        hideIndicator(500);
    });

    document.addEventListener('mouseover', function(e) {
        var li = e.target.closest('.site-nav.style--classic .has-submenu');

        if (li) {
            moveIndicator(li, !lastItem);
        }

        if (li && li === heldItem) {
            clearTimeout(holdTimer);
            li.classList.remove('submenu-hold');
            heldItem = null;
        } else if (li && heldItem && li !== heldItem) {
            clearTimeout(holdTimer);
            heldItem.classList.remove('submenu-hold');
            heldItem = null;
        }
    });

    /* Hide when mouse leaves the entire nav area */
    document.addEventListener('mouseover', function(e) {
        if (!lastItem) return;
        var nav = e.target.closest('.site-nav.style--classic');
        var submenu = e.target.closest('.submenu');
        if (!nav && !submenu) {
            hideIndicator(300);
        }
    });
})();

/* Hide desktop submenu on scroll */
var scrollTimeout;
var lastScrollY = window.scrollY;
window.addEventListener('scroll', function() {
    var delta = Math.abs(window.scrollY - lastScrollY);
    lastScrollY = window.scrollY;
    if (delta < 3) return; /* ignore micro-scrolls */

    document.body.classList.add('is-scrolling');

    /* Kill hover bridge holds + all indicators (main + sticky) */
    document.querySelectorAll('.site-nav.style--classic .submenu-hold').forEach(function(el) {
        el.classList.remove('submenu-hold');
    });
    document.querySelectorAll('.nav-slide-indicator').forEach(function(ind) {
        ind.classList.remove('is-visible');
    });

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
        document.body.classList.remove('is-scrolling');
    }, 100);
}, { passive: true });